<template >
  <Dialog
    :visible="isOpen"
    :showHeader="false"
    :closable="false"
    closeOnEscape
    class="settings-modal"
    aria-label="Settings Menu"
    :modal="true"
  >
  <div v-focustrap aria-modal="true" class="settings-modal">
        <div class="topbar">
      <div class="topbar-title">
        <h3>Settings</h3>
      </div>
      <div ref="settings-dialog-content-ref" class="topbar-closebutton" >
        <IconButton
        :icon="CloseWhiteIcon"
        alt="Close menu"
        autofocus
        :onclick="closeSettings"
        dark
        xxxsmall
        :enterPress="closeSettings"
        ariaLabel="Close Settings"
        />
      </div>
    </div>
    <Tabs :value=0
    >
      <TabList 
        aria-orientation="vertical"  
      >
        <Tab v-for="value in settingsPagesToShow" :key="value.index" :value="value.index" class="settings-menu-item">
          {{ value.title }}
        </Tab>
      </TabList>
      <TabPanels aria-orientation="vertical" class="main">
        <TabPanel :value="0">
          <Account />
        </TabPanel>
        <TabPanel :value="1">
          <Subscription />
        </TabPanel>
        <TabPanel :value="2">
          <!-- TODO: Add the appearance settings -->
          Appearance
        </TabPanel>
        <TabPanel :value="3">
          <LanguageSettings
          class="language-selection"
            :closeSettings="closeSettings"
            :setShowSettingsMainMenu="setShowMainMenu"
            :changeLanguage="changeLanguage"
            :parentLanguage="parentLanguage"
          />
        </TabPanel>
        <TabPanel :value="4">
          <KeywordsDictionary
            :closeSettings="closeSettings"
            :setShowSettingsMainMenu="setShowMainMenu"
            :keywords="keywords"
            :addKeywordToDictionary="addKeywordToDictionary"
            :deleteKeywordFromDictionary="deleteKeywordFromDictionary"
          />
        </TabPanel>
        <TabPanel :value="5">
          <OtherPreferences />
        </TabPanel>
        <TabPanel :value="6">
          <Support />
        </TabPanel>
      </TabPanels>
    </Tabs>
    <div class="app-version">
      {{ "v" + appVersion }}
    </div>
  </div>
  </Dialog>
</template>

<script>
import Account from "../Settings/Account.vue";
import Subscription from "../Settings/Subscription.vue";
import Support from "../Settings/Support.vue";
import KeywordsDictionary from "./KeywordsDictionary";
import LanguageSettings from "./LanguageSettings";
import OtherPreferences from "./OtherPreferences";
import IconButton from "../../components/IconButton.vue";
import CloseWhiteIcon from "../../assets/images/Close-white.svg";
import { editorConstants, SETTINGS_PAGES } from "../../assets/constants";
import { version } from "/package.json";

export default {
  props: {
    isOpen: Boolean,
    closeSettings: Function,
    showMainMenu: Boolean,
    setShowMainMenu: Function,
    keywords: Array,
    addKeywordToDictionary: Function,
    deleteKeywordFromDictionary: Function,
    changeLanguage: Function,
    parentLanguage: Object,
    appearanceOption: Boolean,
    fontOption: Boolean,
    keywordsOption: Boolean,
    captionsLanguageOption: Boolean,
    sessionInfoOption: Boolean,
    feedbackAndHelpOption: Boolean,
    sttOption: Boolean,
    selectedSttType: String,
    changeSttType: Function,
    accountOption: Boolean,
    subscriptionOption: Boolean,
    supportOption: Boolean,
    activeTabIndex: Number,
    setActiveTabIndex: Function,
    pagesToShow: Array,
  },

  components: {
    KeywordsDictionary,
    LanguageSettings,
    IconButton,
    Account,
    Subscription,
    Support,
    OtherPreferences,
  },

  computed: {
    settingsPagesToShow() {
      return Object.fromEntries(
        Object.entries(SETTINGS_PAGES).filter(([key]) =>
          this.pagesToShowState.includes(key)
        )
      );
    },

    appVersion() {
      return process.env.VUE_APP_VERSION || version;
    },
  },

  data() {
    return {
      editorConstants,
      SETTINGS_PAGES,
      CloseWhiteIcon,

      // So we have a fallback default set of pages
      pagesToShowState: this.pagesToShow || [
        "ACCOUNT",
        "SUBSCRIPTION",
        "SUPPORT",
      ],
    };
  },
};
</script>

<style lang="scss">
$border: solid 1px rgba(135, 117, 148, 0.20);
$side-padding: 2.4rem;

.settings-modal {

  .topbar {
      position: sticky;
      top: 0;
      z-index: 1000;
      background: map-get($colours, accent-purple-4);
      border-bottom: $border;
      letter-spacing: 0.04rem;
      line-height: 2.3rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 64px;
    }
    .topbar-title {
      border-right: $border;
      padding: 1.6rem;
      height: 64px;
      width: 224px;
      display: flex;
      align-items: center;
      h3 {
        font-size: 18px;
      }
    }
    .topbar-closebutton {
      padding: 1.6rem $side-padding;
      width: auto;
    }
    &.p-dialog {
    background: map-get($colours, accent-purple-4);
    width: 80rem;
    max-width: 80vw;
    height: 60rem;
    max-height: 80vh;
    border-radius: 0.6rem;
    overflow: hidden;

    .p-dialog-content {
      background: map-get($colours, accent-purple-4);
      color: white;
      padding: 0;
    }
    .p-tablist {
      padding: 0;
      border-right: $border;
      min-width: 224px;
    }

    .p-tablist-tab-list {
      position: relative;
      display: flex;
      flex-direction: column;
      border-right: $border;
      border-style: unset;
      background: inherit;
      .p-tab {
        height: 4rem;
        font-size: 1.4rem;
        font-weight: bold;
        text-align: left;
        padding: 1.2rem $side-padding;
        width: 100%;
        background-color: inherit;
        color: map-get($colours, translucent-white-60);
        transition: all 0.2s ease;
        border: none;
        &:hover:not(:disabled), &:focus {
          background-color: rgba(135, 117, 148, 0.2);
          color: map-get($colours, white);
          filter: none;
          border-bottom: none;
        }
      }
    }
    .p-tablist-content {
      height: 100%;
      min-height: 480px;
    }
    .p-tablist-active-bar {
      display: none;
    }
    .p-tabs {
      display: flex;
      flex-direction: unset;
    }
    .p-tabpanels {
      padding: 0;
      height: 100%;
      width: 100%;
      background: inherit;

      .p-tabpanel {
        padding: 40px 72px 40px 40px;
        > * {
          height: 100%;
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
      }
    }
  }
  .app-version {
    position: absolute;
    bottom: 0.8rem;
    left: $side-padding;
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.4);
    letter-spacing: 0.04rem;
  }
}
</style>
